import React from 'react'
import { Head } from '@inertiajs/react'
import { PublicLayout } from '@/components/frontend/templates/PublicLayout'
import { HeroSection } from '@/components/frontend/organisms/HeroSection'
import { ServicesSection } from '@/components/frontend/organisms/ServicesSection'
import { WorkflowSection } from '@/components/frontend/organisms/WorkflowSection'
import { AboutSection } from '@/components/frontend/organisms/AboutSection'
import { BlogSection } from '@/components/frontend/organisms/BlogSection'
import { FAQSection } from '@/components/frontend/organisms/FAQSection'
import { ContactSection } from '@/components/frontend/organisms/ContactSection'
import { useContactVM } from './Contact.vm'
import { useTranslation } from '@/hooks/useTranslation'
import type { PageProps } from '@/types'
import type { PublicPost } from '@/types/frontend'

type Props = PageProps<{
  featuredPosts: PublicPost[]
  recentPosts: PublicPost[]
}>

const Home: React.FC<Props> = ({ recentPosts, flash }) => {
  const contactForm = useContactVM(flash)
  const { t } = useTranslation()

  return (
    <PublicLayout>
      <Head title={t('head.home_title')} />
      <HeroSection />
      <ServicesSection />
      <WorkflowSection />
      <AboutSection />
      <BlogSection posts={recentPosts} />
      <FAQSection />
      <ContactSection form={contactForm} />
    </PublicLayout>
  )
}

export default Home
